import { styled } from '@mui/system';
import Button from '@mui/material/Button';

import { styles } from '../../types'

import { ButtonProps } from '../types'

export const ButtonStyle = styled(Button)<ButtonProps>`
    color: ${({color, disabled}) => `${(color ==="primary" && styles['primary'][disabled ? 'disabled' : 'active'].color) || color} !important`};
    background-color: ${({color, disabled}) => `${(color === 'primary' && styles['primary'][disabled ? 'disabled' : 'active'].background) || color} !important`};
    border-radius: ${({square}) => `${square ? '8px' : '48px'}`};
    font-weight: 500;
    font-size: 14px;
    text-transform: unset;
    padding: ${({sizeCustom, square}) => `${styles.padding[(square ? 'square' : sizeCustom) || 'large']}`};
    font-family: 'cabin';
    &:hover {
      background: ${({color}) => `${(styles['primary'] && styles['primary'].hover.background) || color} !important`};
    }
`;
